import React, { useState, useEffect } from 'react';
import { Grid, Card, createTheme, ThemeProvider, Chip } from '@mui/material';
import { styled } from '@mui/system';

import ImageDialog from './ImageDialog';
import GridGallery from './GridGallery';

const PageContainer = styled('div')({
  display: 'flex',
  maxHeight: '100%',
});

const GridContainer = styled(Grid)({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'center',
  alignItems: 'center',
  alignContent: 'center',
});


const ChipContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  marginTop: theme.spacing(1),
  marginBottom: theme.spacing(1),
  width: '100%',
  gap: theme.spacing(1),
}));


const ImageGrid = ({ images, ignoreFilters}) => {
  images = images.filter((file) => {
    if (file.includes("pom")) {
      const hasValidOcclude = file.includes("occlude_postproc") && (file.match(/occlude/g) || []).length === 1;
      return file.includes("hide_postproc") || file.includes("_final") || hasValidOcclude;
    }
    return true;
  });

  const [selectedImage, setSelectedImage] = useState(null);
  const [selectedImages, setSelectedImages] = useState(images);
  const [selectedVisualizations, setSelectedVisualizations] = useState(["vto", "product", "pom"]);

  useEffect(() => {
    if (!ignoreFilters) {
      setSelectedImages(images.filter(image => selectedVisualizations.some(vis => image.includes(vis))));
    } else {
      setSelectedImages(images);
    }
  }, [selectedVisualizations]);

  const handleClose = () => {
    setSelectedImage(null);
  };

  const handleClick = (visualization_type) => {
    if (ignoreFilters) return;

    if (selectedVisualizations.includes(visualization_type)) {
      setSelectedVisualizations(selectedVisualizations.filter(vis => vis !== visualization_type));
    } else {
      setSelectedVisualizations([...selectedVisualizations, visualization_type]);
    }
  };

  const handleImageClick = (index) => {
    setSelectedImage(selectedImages[index]);
  };

  return (
    <>
      {
        !ignoreFilters && 
          <ChipContainer>
            <Chip label="VTO" color='primary' onClick={() => handleClick("vto")} variant={selectedVisualizations.includes("vto") ? "filled" : "outlined"} />
            <Chip label="Products" color='primary' onClick={() => handleClick("product")} variant={selectedVisualizations.includes("product") ? "filled" : "outlined"} />
            <Chip label="POM" color='primary' onClick={() => handleClick("pom")} variant={selectedVisualizations.includes("pom") ? "filled" : "outlined"} />
          </ChipContainer>
      }
      <PageContainer>
        <GridContainer>
          <GridGallery imageUrls={selectedImages} handleImageClick={handleImageClick} />
          <ImageDialog open={selectedImage !== null} imageUrl={selectedImage} handleClose={handleClose} />
        </GridContainer>
      </PageContainer>
    </>
  );
};

export default ImageGrid;